module.exports = __webpack_public_path__ + "img/zhang-tiehua.f2eaac56.jpeg";